import React, { useEffect, useRef } from 'react';

const SpiderChart = ({ teamScores, tredeNames }) => {
  const canvasRef = useRef(null);
  
  const tredes = ['vertrouwen', 'conflicten', 'betrokkenheid', 'verantwoording', 'resultaten'];
  
  useEffect(() => {
    drawSpiderChart();
  }, [teamScores]);

  const drawSpiderChart = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d');
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const radius = Math.min(centerX, centerY) - 60;
    
    // Clear canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    // Draw background grid (circles)
    ctx.strokeStyle = '#e2e8f0';
    ctx.lineWidth = 1;
    for (let i = 1; i <= 5; i++) {
      ctx.beginPath();
      ctx.arc(centerX, centerY, (radius / 5) * i, 0, 2 * Math.PI);
      ctx.stroke();
    }
    
    // Draw axes and labels
    const angleStep = (2 * Math.PI) / 5;
    const axisPoints = [];
    
    tredes.forEach((trede, index) => {
      const angle = -Math.PI / 2 + angleStep * index; // Start from top
      const x = centerX + Math.cos(angle) * radius;
      const y = centerY + Math.sin(angle) * radius;
      
      axisPoints.push({ x, y, angle });
      
      // Draw axis line
      ctx.strokeStyle = '#cbd5e1';
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(centerX, centerY);
      ctx.lineTo(x, y);
      ctx.stroke();
      
      // Draw labels
      ctx.fillStyle = '#374151';
      ctx.font = 'bold 14px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      
      // Position labels outside the circle
      const labelX = centerX + Math.cos(angle) * (radius + 30);
      const labelY = centerY + Math.sin(angle) * (radius + 30);
      
      // Split long labels
      const label = tredeNames[trede];
      ctx.fillText(label, labelX, labelY);
      
      // Draw score value
      const score = teamScores[trede] || 0;
      ctx.font = '12px Arial';
      ctx.fillStyle = '#6b7280';
      ctx.fillText(score.toFixed(1), labelX, labelY + 20);
    });
    
    // Draw score markers on axes
    ctx.fillStyle = '#3b82f6';
    tredes.forEach((trede, index) => {
      const score = teamScores[trede] || 0;
      const angle = -Math.PI / 2 + angleStep * index;
      const distance = (score / 5) * radius; // Normalize to 0-5 scale
      
      const x = centerX + Math.cos(angle) * distance;
      const y = centerY + Math.sin(angle) * distance;
      
      ctx.beginPath();
      ctx.arc(x, y, 4, 0, 2 * Math.PI);
      ctx.fill();
    });
    
    // Draw connecting lines between score points
    ctx.strokeStyle = '#3b82f6';
    ctx.lineWidth = 2;
    ctx.fillStyle = 'rgba(59, 130, 246, 0.1)';
    ctx.beginPath();
    
    tredes.forEach((trede, index) => {
      const score = teamScores[trede] || 0;
      const angle = -Math.PI / 2 + angleStep * index;
      const distance = (score / 5) * radius;
      
      const x = centerX + Math.cos(angle) * distance;
      const y = centerY + Math.sin(angle) * distance;
      
      if (index === 0) {
        ctx.moveTo(x, y);
      } else {
        ctx.lineTo(x, y);
      }
    });
    
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    
    // Draw scale numbers
    ctx.fillStyle = '#9ca3af';
    ctx.font = '10px Arial';
    ctx.textAlign = 'center';
    for (let i = 1; i <= 5; i++) {
      const scaleRadius = (radius / 5) * i;
      ctx.fillText(i.toString(), centerX + scaleRadius + 10, centerY - 5);
    }
    
    // Draw center point
    ctx.fillStyle = '#374151';
    ctx.beginPath();
    ctx.arc(centerX, centerY, 2, 0, 2 * Math.PI);
    ctx.fill();
  };

  return (
    <div style={{
      background: 'white',
      padding: '2rem',
      borderRadius: '15px',
      marginBottom: '2rem',
      boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
      textAlign: 'center'
    }}>
      <h3 style={{ 
        fontSize: '1.5rem', 
        fontWeight: 'bold', 
        color: '#2d3748',
        marginBottom: '2rem'
      }}>
        🕸️ Gezin Sterkte Radar
      </h3>
      
      <canvas
        ref={canvasRef}
        width={400}
        height={400}
        style={{
          maxWidth: '100%',
          height: 'auto',
          border: '1px solid #e2e8f0',
          borderRadius: '8px'
        }}
      />
      
      <div style={{
        marginTop: '1rem',
        fontSize: '0.875rem',
        color: '#6b7280'
      }}>
        <p>Hoe verder naar buiten, hoe sterker het gezin op die dimensie</p>
        <p style={{ margin: '0.5rem 0 0 0' }}>
          Schaal: 1 (centrum) tot 5 (buitenrand)
        </p>
      </div>
    </div>
  );
};

export default SpiderChart;